<template>
    <svg fill="white" viewBox="0 0 24 24" aria-hidden="true">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.7227 4.37179C23.0951 4.77074 23.3625 5.2668 23.4982 5.81032C24 7.81645 24 12 24 12C24 12 24 16.1835 23.4982 18.1897C23.3625 18.7332 23.0951 19.2293 22.7227 19.6282C22.3503 20.0271 21.8861 20.315 21.3764 20.4629C19.5 21 12 21 12 21C12 21 4.5 21 2.62364 20.4629C2.11393 20.315 1.64966 20.0271 1.27729 19.6282C0.904916 19.2293 0.637506 18.7332 0.501818 18.1897C0 16.1835 0 12 0 12C0 12 0 7.81645 0.501818 5.81032C0.637506 5.2668 0.904916 4.77074 1.27729 4.37179C1.64966 3.97285 2.11393 3.68502 2.62364 3.5371C4.5 3 12 3 12 3C12 3 19.5 3 21.3764 3.5371C21.8861 3.68502 22.3503 3.97285 22.7227 4.37179ZM17 12L9 8V16L17 12Z"
        />
    </svg>
</template>
